import React from "react"; 
import { HiOutlineViewList } from 'react-icons/hi'; 
import './style.css'; 
let couActStack=(props)=> { 
  return(
  <div>
    <nav class="navbar navbar-expand-lg py-3">
      <div class="container">
        <a href="#" class="navbar-brand">
          <img src="https://bootstrapious.com/i/snippets/sn-nav-logo/logo.png" width="45" alt="" class="d-inline-block align-middle mr-2" /> <span className="text-uppercase font-weight-bold">Company</span>
        </a>
        <button id='navResponsiveButton' type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation" className="navbar-toggler"><span className="navbar-toggler-icon"></span> 
          <HiOutlineViewList size={30} id='threebutt' />
        </button>
        <div id="navbarSupportedContent" className="collapse navbar-collapse">
          <ul className="navbar-nav ml-auto">
            <li className="nav-item active"><a href="#" className="nav-link"  onClick={()=>props.history.push('/')} >Home <span className="sr-only">(current)</span></a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link" >Services</a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link" >About </a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link" >Contact </a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link" id='cas-link'>Case Studies</a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link"  onClick={()=>props.history.push('/signin')}      >Signin</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <div id="centerME">
      <div className="boxStAc">
        <h4 id="h4">
  
  Coustomer - Actor - StackeHolder
  
  </h4>
        <br></br>
        <h4 id="h4T">
  
  Write Down Who is Customer , Actor And StackeHolder of the intiative
  </h4>
        <h6 id='h6'>
  Customer : Person who is responsible for paying you and has Authurity to cancel usage of your service.
  </h6>
        <h6 id='h6'>
  Actor : Any Person or System who interact with your service in order to accamplish a task. Acustomer can also be actor.
  </h6>
        <h6 id='h6'>
  StackeHolder : Group of people Stake in outcome of your intiative. They May or May not be customer or actor.
  </h6>
        <div style={{width: '100%',display: 'flex',alignItems: 'flex-start',justifyContent: 'space-around',flexDirection: 'row',flexWrap: 'wrap',marginTop:40}}>
          <textarea name="w3review" rows="5" cols="35" placeholder="Customer" id="textAre"></textarea>
          <textarea name="w3review" rows="5" cols="35" placeholder="Actor" id="textAre"></textarea>
          <textarea name="w3review" rows="5" cols="35" placeholder="StackHolder" id="textAre"></textarea>
        </div>
        <div id="flexEnd">
          <button className="button2" onClick={()=>props.history.push('/DimenProb')} id='BackNext'>Back</button>
          <button className="button2" onClick={()=>props.history.push('/buyerMotivation')} id='BackNext'>Next</button>
        </div>
      </div>
    </div>
  </div>) }
  
  
  export default couActStack;